import React from 'react';

interface ActionButtonProps {
  label: string;
  icon?: string;
  onClick: () => void;
  gradient: string;
  disabled?: boolean;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  label,
  icon,
  onClick,
  gradient,
  disabled = false
}) => {
  return (
    <button
      className="action-button"
      style={{ background: gradient }}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && <span className="button-icon">{icon}</span>}
      <span className="button-label">{label}</span>
      <span className="button-arrow">→</span>
    </button>
  );
};
